import React from 'react';
import { useListChargePointLogs } from '../../../../../../app/ApiGen';
import { DataErrorHandler } from '../../../../../../components/ErrorHandler';
import { Loading, Workspace } from '../../../../../../design-system';
import { useEndDateState, useSetDateRange, useStartDateState } from '../../../../../../utils/dateRange';
import { normalise } from '../../../../../../utils/request';
import { useChargePoint } from '../Provider';
import { ChargePointLogsTable } from './components/ChargePointLogsTable';

const LogsView: React.FC = () => {
  const [fromDate, setFromDate] = useStartDateState();
  const [toDate, setToDate] = useEndDateState();
  const setDateRange = useSetDateRange(setFromDate, setToDate);

  const { chargePoint } = useChargePoint();
  const chargePointId: string = chargePoint?.id ?? '';

  const { loading, error, data, refetch } = useListChargePointLogs({
    id: chargePointId,
    queryParams: { from: fromDate.toISOString(), to: toDate.toISOString() },
  });

  if (loading && !data) {
    return (
      <Workspace>
        <Loading />
      </Workspace>
    );
  }

  if (error || !data) {
    return <DataErrorHandler description="Unable to load charge point logs" error={error} refetch={refetch} />;
  }

  return (
    <Workspace maxWidth="xl">
      <ChargePointLogsTable
        tableProps={{
          loading,
          refetch,
          chargePointLogs: normalise(data),
          exportFileName: `logs-${chargePoint?.referenceId ?? chargePointId}`,
        }}
        dateProps={{ dateRange: { fromDate, toDate }, setDateRange }}
      />
    </Workspace>
  );
};

export default LogsView;
